import { intelligentPhotoCaptureConstants } from '../constants';
export const INTELLIGENT_PHOTO_CAPTURE_FILE_DOWNLOAD_START = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_FILE_DOWNLOAD_START`;
export const INTELLIGENT_PHOTO_CAPTURE_FILE_DOWNLOAD_COMPLETE = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_FILE_DOWNLOAD_COMPLETE`;
export const photoCaptureFileDownloadStartAction = () => ({
    type: INTELLIGENT_PHOTO_CAPTURE_FILE_DOWNLOAD_START,
    payload: {}
});
export const photoCaptureFileDownloadCompleteAction = () => ({
    type: INTELLIGENT_PHOTO_CAPTURE_FILE_DOWNLOAD_COMPLETE,
    payload: {}
});
//# sourceMappingURL=photoCaptureIntelligentDownloadArtifactsAction.js.map